<template>
  <div :class="$style.purchase" class="isStylePageContent isPaddingBottom">
    <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top" autocomplete="off">
      <el-row>
        <el-col :span="24">
          <h4>{{ purchaseText }}資訊</h4>
          <el-form-item :label="`${purchaseText}點`" required>
            <el-select v-if="purchaseType === 'purchase'" v-model="shippingPoint" :disabled="$store.getters['inventory/inventoryListLength'] > 0">
              <el-option :label="`廠商`" value="manufacturer"></el-option>
              <el-option v-for="item in productsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-if="purchaseType === 'return'" v-model="shippingPoint" :disabled="$store.getters['inventory/inventoryListLength'] > 0">
              <el-option :label="`廠商`" value="manufacturer"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自訂單號" required>
            <el-input v-model="no" />
          </el-form-item>
          <el-form-item label="備註" required>
            <el-input v-model="note" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div>
            <div :class="$style.topBtn">
              <h4>{{ purchaseText }}商品</h4>
              <div :class="$style.topBtn__self">
                <el-button v-show="shippingPoint !== ''" class="is-round" type="primary" @click="byItemNumber"> 依貨號{{ purchaseText }} </el-button>
                <el-button v-show="shippingPoint !== ''" class="is-round" type="primary" @click="byItemCategory"> 依分類{{ purchaseText }} </el-button>
              </div>
            </div>

            <!-- 進/出貨商品 -->
            <el-table ref="inventoryTable" :class="$style.inventoryTable" :data="selectedProducts">
              <el-table-column label="圖片" width="180">
                <template slot-scope="scope">
                  <img v-if="scope.row.params.images[0].path" class="goods-img" :src="scope.row.params.images[0].path" alt="" />
                  <img v-else :src="require(`@assets/images/icons/face-cream.svg`)" />
                </template>
              </el-table-column>

              <el-table-column label="商品" width="180">
                <template slot-scope="scope">{{ scope.row.serviceTitle }}</template>
              </el-table-column>

              <el-table-column label="商品分類" width="180">
                <template slot-scope="scope">{{ scope.row.petCategory }}</template>
              </el-table-column>

              <el-table-column label="分店及規格" width="180">
                <template slot-scope="scope">
                  <div class="goods-info">
                    <p> {{ scope.row.storeTitle }}</p>
                    <p v-for="(spec, index) in scope.row.spec" :key="index">{{ spec.title }}: {{ spec.values[0].title }} </p>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="商品貨號" width="180">
                <template slot-scope="scope">{{ scope.row.no }}</template>
              </el-table-column>

              <el-table-column :label="`商品${purchaseText}數量`">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.inventory" class="goods-amount"></el-input>
                </template>
              </el-table-column>

              <el-table-column>
                <template slot-scope="scope">
                  <el-button :class="$style.btnNoStyle" @click="deleteProductList(scope.row)">
                    <BaseIcon name="xmark" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <!-- 依貨號進貨 Dialog -->
    <el-dialog class="detail-dialog" :title="`依貨號${purchaseText}`" :destroy-on-close="true" :visible.sync="dialogTableVisible" top="0" append-to-body width="950px" @closed="closeNoDialogToDo">
      <el-tabs v-model="activeTab" stretch>
        <el-tab-pane label="掃描條碼" name="scan"></el-tab-pane>
        <el-tab-pane label="輸入貨號" name="userInput"></el-tab-pane>
      </el-tabs>
      <div :class="$style.upperSearch">
        <div :class="$style.selectInput">
          <el-select v-model="search.productId" class="search-store">
            <el-option v-for="product in filterProducts" :key="product.id" :label="product.name" :value="product.id"></el-option>
          </el-select>
          <el-input v-model="search.no" :disabled="activeTab === 'scan'" class="search-goods" placeholder="請輸入商品名稱或是商品貨號" @keyup.enter.native="getItemByNo">
            <i slot="suffix" class="el-icon-search el-input__icon" style="cursor: pointer;" @click="getItemByNo"> </i>
          </el-input>
        </div>
        <el-button v-if="activeTab === 'userInput'" type="primary" class="is-round" @click="getItemByNo">
          搜索商品
        </el-button>
      </div>
      <div class="scroll-wrapper">
        <DetailTable ref="detailTable" :dialog-status="true" :full-width="true" :spec-list="specList" :purchase-text="purchaseText" @closeNoDialogFromDetailTable="closeNoDialogFromDetailTable">
          <el-table-column>
            <template slot-scope="scope">
              <el-button :class="$style.btnNoStyle" @click="deleteDialogTableData(scope.row)">
                <BaseIcon name="xmark" />
              </el-button>
            </template>
          </el-table-column>
        </DetailTable>
      </div>
      <el-button class="is-round btn-confirm" type="primary" @click="updateInventoryList">
        確認
      </el-button>
      <el-button class="is-round btn-cancel" @click="dialogTableVisible = false">
        取消
      </el-button>
    </el-dialog>

    <!-- 調配數量異常 Dialog -->
    <el-dialog class="detail-dialog" title="調配數量異常" :destroy-on-close="true" :visible.sync="allocateTableVisible" top="0" append-to-body width="950px" @closed="closeNoDialogToDo">
      <p class="text-center mb-0">同品項同規格產品，不同分店的調配數量總和大於出貨店，請修改各品項調配數量，以便完成進退貨</p>
      <hr class="my-4" />
      <el-table ref="allocateTable" :class="$style.inventoryTable" :data="allocateData">
        <template>
          <el-table-column label="" width="120" class="py-0">
            <template slot-scope="allocate">
              <div v-if="allocate.row.maximum < allocate.row.inventory" class="d-flex flex-column allocate-pink text-danger">
                <p class="text-center">溢出數</p>
                <p class="fs-2 text-center">{{ allocate.row.inventory - allocate.row.maximum }}</p>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="" width="120">
            <template slot-scope="allocate">
              <img :src="allocate.row.image" alt="" class="goods-img" />
            </template>
          </el-table-column>

          <el-table-column label="商品" width="180">
            <template slot-scope="allocate">
              <p class="mt-0 mb-1">{{ allocate.row.title }}</p>
              <span>{{ allocate.row.category }}</span>
            </template>
          </el-table-column>

          <el-table-column label="分店及規格" width="180">
            <template slot-scope="allocate">
              <p class="mt-0 mb-1">{{ allocate.row.store.name }}</p>
              <p v-for="(spec, index) in allocate.row.spec" :key="index" class="mt-0 mb-1">{{ spec[0] }}：{{ spec[1] }}</p>
            </template>
          </el-table-column>

          <el-table-column label="商品貨號" prop="id" width="180"></el-table-column>

          <el-table-column label="進貨數量">
            <template slot-scope="allocate">
              <el-input v-model="allocate.row.inventory" class="goods-amount"></el-input>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-button class="is-round btn-confirm mt-4" type="primary" :disabled="!allocateCheck" @click="updateSelectedProducts">
        確認
      </el-button>
      <el-button class="is-round btn-cancel" @click="allocateTableVisible = false">
        取消
      </el-button>
    </el-dialog>

    <div :class="$style.footer">
      <el-button class="is-round" @click="removeTempInfo($event)">取消</el-button>
      <el-button class="is-round" type="primary" :disabled="selectedProducts.length === 0" @click="addInventory">確認新增</el-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import DetailTable from './DetailTable.vue'
export default {
  name: 'PurchaseInformation',
  components: { DetailTable },
  props: {
    purchaseType: {
      type: String,
      default: 'purchase',
    },
  },
  data() {
    return {
      selectedProducts: [],
      submitData: {},
      no: '', // 自訂單號
      note: '', // 備註
      tryingFetch: false, // fetch 狀態
      shippingPoint: '', // 出貨點
      dialogTableVisible: false, // 依貨號進貨彈窗
      allocateTableVisible: false, // 調配數量異常彈窗
      search: {
        productId: '',
        no: '',
      },
      specList: [],
      productsList: [], // 分店列表
      activeTab: 'userInput', // 活躍的tab
      allocateData: [],
    }
  },
  computed: {
    inventoryList() {
      return this.$store.state.inventory.list
    },
    formRules() {
      return {}
    },
    /**
     * @description 要filter掉所選的商店
     */
    filterProducts() {
      if (this.shippingPoint === 'manufacturer') {
        return this.products
      }
      if (this.shippingPoint !== 'manufacturer') {
        let productList = this.products.filter((item) => item.id !== this.shippingPoint)
        // 這邊先不放上廠商
        // productList.push({
        //   storeType: 'store',
        //   type: 'service',
        //   name: '廠商',
        //   state: 1,
        //   id: 'manufacturer'
        // })
        return productList
      }
      return this.products
    },
    /**
     * @description 進貨 or 退貨的key值
     */
    purchaseText() {
      return this.purchaseType === 'purchase' ? '進貨' : '退貨'
    },
    products() {
      return this.$store.state.product.cached
    },
    /**
     * @description 此次api形式
     */
    operatorType() {
      if (this.purchaseType === 'purchase') {
        return 'add'
      }
      if (this.purchaseType === 'return') {
        return 'sub'
      }
    },
    allocateCheck() {
      return this.allocateData.every((item) => item.value * -1 >= item.inventory)
    },
  },

  watch: {
    shippingPoint(nvl, ovl) {
      this.$store.commit('inventory/USER_SELECT_SHIPPING_POINT', nvl)
      this.$emit('selectedShippingPoint', nvl)
    },
    inventoryList: {
      handler(newVal) {
        this.selectedProducts = cloneDeep(newVal)
      },
      immediate: true,
    },
  },
  async mounted() {
    if (this.$store.state.inventory.userSelectShippingPoint.length > 0) {
      this.shippingPoint = this.$store.state.inventory.userSelectShippingPoint
    }
    await this.fetchProductList()
  },
  created() {
    this.saveTempInfo()
  },
  methods: {
    /**
     * @description 刪除依貨號彈窗的table
     */
    deleteDialogTableData(row) {
      this.specList = this.specList.filter((item) => item.id !== row.id)
    },
    /**
     * @description 刪除產品列表
     */
    deleteProductList(row) {
      this.$store.commit('inventory/DELETE_ITEM', row) // 刪除list其中一列
    },
    /**
     * @description 確認新增function
     */
    async addInventory() {
      try {
        if (this.selectedProducts.length === 0) {
          this.$message()
        } else {
          let submitData = {
            type: 'goods',
            operatorType: this.operatorType,
            no: this.no,
            note: this.note,
            product_id: this.shippingPoint === 'manufacturer' ? null : this.shippingPoint,
            sizes: this.composeForSaveProducts(this.selectedProducts),
          }
          await this.validateAddSubStoreSubmitData(submitData)
          await this.$store.dispatch('inventory/addSubStore', submitData)
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.$emit('goInventoryManagement')
          this.$store.commit('inventory/TO_EMPTY_LIST')
          this.removeTempInfo()
        }
      } catch (error) {
        console.log(error)
        if (error.data) {
          this.allocateData = []
          let data = []
          error.data.items.forEach((err) => {
            this.getAllocateData(err.spec_tag, err.product_id, err)
            data = this.selectedProducts.filter((item) => item.spec_tag === err.spec_tag)
          })
          // 將圖片與標題等資料放入allocateData渲染彈窗
          this.allocateData.forEach((item, index) => {
            item.title = data[index].title
            item.category = data[index].petCategory
            item.image = data[index].params.images[0].path
            item.id = data[index].no
            item.inventory = Number(data[index].inventory)
          })
          this.allocateData = JSON.parse(JSON.stringify(this.allocateData))
          this.allocateTableVisible = true
        }

        this.$message({
          message: error.message,
          type: 'error',
        })
      }
    },
    openAllocateModal() {
      this.allocateTableVisible = true
    },
    updateSelectedProducts() {
      this.selectedProducts = this.selectedProducts.map((select) => {
        const allocate = this.allocateData.find((allocate) => allocate.id === select.no)
        if (allocate) {
          select.inventory = allocate.inventory
        }
        return select
      })
      this.allocateTableVisible = false
    },
    /**
     * @description 驗證要提交的資料
     */
    async validateAddSubStoreSubmitData(submitData) {
      return new Promise((resolve, reject) => {
        if (typeof submitData.product_id === 'string' && submitData.product_id.length === 0) {
          reject(new Error('請選擇分店'))
        }
        if (submitData.no.length === 0) {
          reject(new Error('請填入正確自訂單號'))
        }
        if (submitData.note.length === 0) {
          reject(new Error('請填入正確備註'))
        }
        if (submitData.sizes.length === 0) {
          reject(new Error('請選擇產品'))
        }
        if (submitData.sizes.length > 0) {
          for (let i = 0, len = submitData.sizes.length; i < len; i++) {
            const value = +submitData.sizes[i].value
            if (isNaN(value) || value <= 0) {
              reject(new Error('請填入正確庫存'))
            }
          }
        }
        resolve()
      })
    },
    /**
     * @description 組成可以儲存的資料格式
     */
    composeForSaveProducts(selectedProducts) {
      try {
        return selectedProducts.map((cur) => ({ id: cur.id, value: +cur.inventory }))
      } catch (error) {
        console.error(error.message)
      }
    },
    async fetchProductList() {
      const { items } = await this.$store.dispatch('product/fetchList', {
        limit: 10000,
        page: 1,
        paginate: 0,
      })
      this.productsList = items
    },
    handleSelectionChange() {},
    /**
     * @description 選擇進貨商品
     */
    goCategory() {
      this.$emit('goCategory')
      const tempInfo = []
      tempInfo.push(this.no, this.note)
      window.localStorage.setItem('tempInfo', JSON.stringify(tempInfo))
    },
    /**
     * @description 依貨號進貨btn
     */
    byItemNumber() {
      this.dialogTableVisible = !this.dialogTableVisible
    },
    /**
     * @description 依分類進貨
     */
    byItemCategory() {
      this.goCategory()
    },
    /**
     * @description 依貨號搜尋
     */
    async getItemByNo() {
      try {
        // 如果是掃瞄，就不用給他點
        if (this.activeTab === 'scan') {
          return
        }
        await this.validateSearch()
        const res = await this.$store.dispatch('inventory/getItemByNo', {
          productId: this.search.productId === 'manufacturer' ? null : this.search.productId,
          no: this.search.no,
        })
        // 如果空的直接放進去
        if (this.specList.length === 0) {
          this.specList.push(res.items)
        }
        // 如果是有東西的，要去判斷是否已經存在，如果存在不放入，不存在則放入
        if (this.specList.length > 0) {
          const idsMap = this.specList.map((item) => item.id)
          if (!idsMap.includes(res.items.id)) {
            this.specList.push(res.items)
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 驗證search資料
     */
    validateSearch() {
      return new Promise((resolve, reject) => {
        if (this.search.productId.length === 0) {
          reject(new Error('請選擇分店'))
        }
        if (this.search.no.length === 0) {
          reject(new Error('請輸入貨號'))
        }
        resolve()
      })
    },
    /**
     * @description 關閉依貨號進貨的視窗
     */
    closeNoDialogToDo() {
      this.$set(this.search, 'productId', '')
      this.$set(this.search, 'no', '')
      this.specList = []
    },
    updateInventoryList() {
      this.$refs.detailTable.updateInventoryList()
    },
    /**
     * @description 關閉依貨號進貨的窗
     */
    closeNoDialogFromDetailTable() {
      this.dialogTableVisible = false
      this.closeNoDialogToDo()
    },
    // 將單號與備註存入localstorage
    saveTempInfo() {
      if (window.localStorage.getItem('tempInfo')) {
        const arr = JSON.parse(window.localStorage.getItem('tempInfo'))
        this.no = arr[0]
        this.note = arr[1]
      }
    },
    // 清空單號與備註的localstorage
    removeTempInfo(e) {
      this.no = ''
      this.note = ''
      window.localStorage.removeItem('tempInfo')
      if (e && e.target.innerText === '取消') {
        this.$emit('goInventoryManagement')
      }
    },
    // 取得調配異常分店與庫存資料
    getAllocateData(spec, id, data) {
      const arr = spec.split(',')
      let obj = {}
      const newSpec = []
      // 將spec的辨識id去除並轉換為物件
      arr.forEach((item) => {
        const newItem = item.split(':')
        let str = []
        newItem.forEach((newItem) => {
          str.push(newItem.slice(0, -9))
        })
        newSpec.push(str)
      })
      // 判斷分店名稱
      const store = this.productsList.find((item) => item.id === id)
      obj = {
        ...data,
        store: store,
        spec: newSpec,
      }
      this.allocateData.push(obj)
    },
  },
}
</script>

<style lang="scss" module>
// .purchase {
//   :global {}
// }

.upperSearch {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.selectInput {
  display: flex;
  gap: 10px;
}

.topBtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  &__self {
    :global {
      .el-button {
        width: 150px;
        height: 44px;
      }
    }
  }
}

.inventoryTable {
  :global {
    .goods-img {
      width: 80px;
      margin-left: 20px;
    }

    th {
      &:first-child {
        padding-left: 10px;
      }

      &:last-child {
        padding-right: 10px;
      }
    }

    td {
      &:first-child {
        padding-left: 10px;
      }

      &:last-child {
        padding-right: 10px;
      }
    }
  }
}

.footer {
  padding: 20px 40px;
  width: calc(100% - 72px);
  position: fixed;
  left: 72px;
  bottom: 0;
  display: flex;
  gap: 10px;
  box-shadow: 3px -3px 10px #00000019;
  background-color: #fff;
  z-index: 2;

  :global {
    button {
      flex: 1;
    }
  }
}

.btnNoStyle {
  border: none;
  background-color: transparent;

  &:hover,
  &:focus {
    background-color: transparent;
  }
}
</style>
<style lang="scss">
.detail-dialog {
  .el-dialog__body {
    padding: 0;
  }

  .search-store {
    margin-bottom: 10px;
  }

  .search-goods {
    margin-bottom: 20px;
  }

  .scroll-wrapper {
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  .btn-confirm {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .btn-cancel {
    display: block;
    width: 100%;
    margin: 0;
  }

  .allocate-pink {
    background: pink;
  }
}

.topBtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  &__self {
    :global {
      .el-button {
        width: 150px;
        height: 44px;
      }
    }
  }
}
</style>
